import { Subscription } from 'rxjs/Subscription';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { EVENTS } from '../../bus/events.const';

@Component
export class SearchBoxMixin extends Vue {
  inputFocused = false;
  subscription = new Subscription();

  @Prop()
  autofocus: boolean;

  @Prop()
  value: string;

  $refs: {
    input: HTMLInputElement;
  };

  mounted() {
    this.subscription.add(this.$x.on(EVENTS.FocusSearchInput).subscribe(() => this.$refs.input.focus()));
    this.subscription.add(this.$x.on(EVENTS.BlurSearchInput).subscribe(() => this.$refs.input.blur()));
    this.subscription.add(this.$x.on(EVENTS.OpenEmpathyX).subscribe(() => {
      if (this.autofocus && !this.value) {
        Vue.nextTick(() => this.$refs.input.focus());
      }
    }));
  }

  beforeDestroy() {
    this.subscription.unsubscribe();
  }

  onBlur() {
    this.inputFocused = false;
    this.$x.emit(EVENTS.InputBlur);
  }

  onClear(input: HTMLInputElement) {
    this.$x.emit(EVENTS.ClearInputQuery);
    input.focus();
  }

  onClick() {
    this.$x.emit(EVENTS.InputClicked);
  }

  onFocus() {
    this.inputFocused = true;
    this.$x.emit(EVENTS.InputFocused);
  }

  onInput(event: any) {
    const newValue = event.target.value;
    if (newValue !== this.value) {
      // As IE fires an input event when the input is blurred, we need to put this if here.
      this.$x.emit(EVENTS.InputQueryChanged, newValue);
    }
  }

  onKeydown(event: KeyboardEvent) {
    const key = event.key || event.which || event.keyCode;
    if (key === 'Enter' || key === 13) {
      this.$x.emit(EVENTS.InputEnterPressed);
    } else if (key === 'Escape' || key === 27) {
      this.$x.emit(EVENTS.InputEscapePressed);
    } else if (
      key === 'ArrowLeft' || key === 37 ||
      key === 'ArrowRight' || key === 39) {
      this.$x.emit(EVENTS.InputArrowPressed, key);
    } else if (
      key === 'ArrowUp' || key === 38 ||
      key === 'ArrowDown' || key === 40) {
      event.preventDefault();
      this.$x.emit(EVENTS.InputArrowPressed, key);
    } else if (key === '<' || key === 188 || key === '>' || key === 190) {
      event.preventDefault();
    }
  }
}
